import React, { Component } from "react";
import { injectIntl } from "react-intl";
import IntlMessages from "../../../helpers/IntlMessages";
import {
  Row,
  Card,
  CardBody,
  Input,
  InputGroup,
  InputGroupAddon,
  Button,
  Alert,
} from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import axios from "axios";import createSocket from "../../../helpers/createSocket";
import { END_POINT, END_POINT_SOCKET } from "../../../constants/defaultValues";
import {
  NotificatioErrController,
  NotificatioSucController,
} from "../../../helpers/Utils";
import FacebookConversationList from "./FacebookConversationList";
import FacebookMessageCard from "./FacebookMessageCard";
import QuickReplyPanel from "./QuickReplyPanel"; // Phase 2
import moment from "moment";

class FacebookChatApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      USER_PARENT_ID: localStorage.getItem("b"),
      pages: [],
      conversations: [],
      filteredConversations: [], // Phase 1: Filtered list
      selectedConversation: null,
      messages: [],
      messageInput: "",
      loadingConversations: true,
      loadingPages: true,
      loadingMessages: false,
      sendingMessage: false,
      isSyncing: false,
      // Phase 1: Foundation Enhancement
      searchQuery: "",
      selectedPageFilter: "", // Filter by page_id
      unreadCount: 0,
      showNotesPanel: false,
      // Phase 2: Quick Replies
      showQuickReplyPanel: false,
      // 24h Window Feature
      selectedMessageTag: "", // For sending outside 24h window
      // Phase 3: Attachments
      selectedAttachment: null, // { file, preview, type }
      uploadingAttachment: false,
      // Token Status
      tokenStatus: null, // { has_expired, expired_count, pages }
      tokenCheckDone: false,
      // Manual Token States
      showManualToken: false,
      manualToken: "",
      previewPages: [],
      selectedPageIds: new Set(),
      previewLoading: false,
      connectingManualToken: false,
      socialError: null,
      socialSuccess: null,
    };
    this.socket = createSocket();
    this._scrollBarRef = null;
    this.fileInputRef = React.createRef();
    this.searchTimeout = null;
  }

  componentDidMount() {
    // Join socket room
    this.socket.emit("join room", {
      room_id: this.state.USER_PARENT_ID,
    });

    // Track connection status
    this.socket.on("connect", () => {
      // Join socket room
      this.socket.emit("join room", {
        room_id: this.state.USER_PARENT_ID,
      });
    });

    // If already connected, join immediately
    if (this.socket.connected) {
      this.socket.emit("join room", {
        room_id: this.state.USER_PARENT_ID,
      });
    }

    // Listen for new Facebook messages
    this.socket.on("facebook message", (data) => {
      this.handleNewMessage(data);
      // Play notification sound if available
      if (window.Audio) {
        try {
          const audio = new Audio("/sounds/notification.mp3");
          audio.volume = 0.5;
          audio.play().catch(() => {}); // Ignore if blocked
        } catch {}
      }
    });

    // Debug socket connection status
    this.socket.on("disconnect", (reason) => {
      console.log("[FacebookChatApp] Socket disconnected:", reason);
    });

    this.loadPages();
    this.loadConversations();
    this.checkTokenStatus();
    // Ensure all pages are subscribed to receive webhook events
    this.resubscribeWebhooks();
  }

  componentWillUnmount() {
    this.socket.off("facebook message");
    this.socket.off("connect");
    this.socket.off("disconnect");
    this.socket.close();
  }

  getAuthConfig = () => {
    const token = localStorage.getItem("access_token");
    return { headers: { Authorization: `Bearer ${token}` } };
  };

  handleConnectFacebookOAuth = async () => {
    try {
      const user_id = localStorage.getItem("b");
      const redirectUrl = window.location.href.split("?")[0];
      const response = await axios.get(
        `${END_POINT}/api/facebook/login?user_id=${user_id}&redirect_url=${encodeURIComponent(
          redirectUrl,
        )}`,
        this.getAuthConfig(),
      );
      if (response.data.authUrl) {
        window.location.href = response.data.authUrl;
      }
    } catch (err) {
      this.setState({ socialError: "Không thể kết nối Facebook" });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // Scroll to bottom when messages change
    if (prevState.messages.length !== this.state.messages.length) {
      // Small timeout to allow render
      setTimeout(() => {
        this.scrollToBottom();
      }, 100);
    }

    // Handle external conversation selection (Unified Tab)
    if (
      this.props.detailsConversationId &&
      this.props.detailsConversationId !== prevProps.detailsConversationId
    ) {
      const targetConv = this.state.conversations.find(
        (c) => c.id === this.props.detailsConversationId,
      );
      if (targetConv) {
        this.handleSelectConversation(targetConv);
      }
    }

    // Auto-refresh pages if empty when switching to this tab
    if (
      this.props.activeTab === "facebook" &&
      prevProps.activeTab !== "facebook" &&
      this.state.pages.length === 0 &&
      !this.state.loadingPages
    ) {
      this.loadPages();
    }
  }

  scrollToBottom = () => {
    if (this._scrollBarRef) {
      const scrollEl = this._scrollBarRef._container;
      if (scrollEl) {
        scrollEl.scrollTop = scrollEl.scrollHeight;
      }
    }
  };

  handleSyncMessages = async () => {
    try {
      this.setState({ isSyncing: true });
      const response = await axios.post(`${END_POINT}/api/facebook/sync`, {
        user_id: this.state.USER_PARENT_ID,
      });

      if (response.data.success) {
        this.loadConversations();
      }
    } catch (err) {
      console.error("Sync error:", err);
    } finally {
      this.setState({ isSyncing: false });
    }
  };

  loadPages = async () => {
    try {
      const response = await axios.get(
        `${END_POINT}/api/facebook/pages?user_id=${this.state.USER_PARENT_ID}`,
        this.getAuthConfig(),
      );
      this.setState({ pages: response.data.data || [], loadingPages: false }, () => {
        // Auto sync messages on login/load
        this.handleSyncMessages();
      });
    } catch (err) {
      console.error("Error loading Facebook pages:", err);
      this.setState({ loadingPages: false });
    }
  };

  // Check Facebook token validity for all connected pages
  checkTokenStatus = async () => {
    try {
      const response = await axios.get(
        `${END_POINT}/api/facebook/token-status?user_id=${this.state.USER_PARENT_ID}`,
        this.getAuthConfig(),
      );
      if (response.data.success) {
        this.setState({
          tokenStatus: response.data.data,
          tokenCheckDone: true,
        });
      }
    } catch (err) {
      console.error("Error checking token status:", err);
      this.setState({ tokenCheckDone: true });
    }
  };

  // Silently re-subscribe all pages to webhook events
  // This ensures real-time messages work even for pages connected before subscription was implemented
  resubscribeWebhooks = async () => {
    try {
      const response = await axios.post(
        `${END_POINT}/api/facebook/resubscribe-webhooks`,
        { user_id: this.state.USER_PARENT_ID },
        this.getAuthConfig(),
      );
      if (response.data.success) {
        console.log(
          "[FacebookChatApp] Webhook re-subscribe result:",
          response.data.data,
        );
      }
    } catch (err) {
      // Silently fail - this is a background operation
      console.error("[FacebookChatApp] Webhook re-subscribe failed:", err.message);
    }
  };

  loadConversations = async () => {
    try {
      this.setState({ loadingConversations: true });
      const { selectedPageFilter } = this.state;

      let url = `${END_POINT}/api/facebook/conversations?user_id=${this.state.USER_PARENT_ID}`;
      if (selectedPageFilter) {
        url += `&page_id=${selectedPageFilter}`;
      }

      const response = await axios.get(url);
      const conversations = response.data.data || [];

      this.setState(
        {
          conversations: conversations,
          filteredConversations: conversations,
          loadingConversations: false,
        },
        () => {
          // Notify Parent (message.js) about updated conversations for "All" tab
          if (this.props.onConversationsUpdate) {
            this.props.onConversationsUpdate(conversations);
          }
          this.performSearch(this.state.searchQuery);
        },
      );

      // Load unread count
      this.loadUnreadCount();
    } catch (err) {
      console.error("Error loading conversations:", err);
      this.setState({ loadingConversations: false });
    }
  };

  // Phase 1: Load unread conversation count
  loadUnreadCount = async () => {
    try {
      const { selectedPageFilter } = this.state;
      let url = `${END_POINT}/api/facebook/conversations/unread-count?user_id=${this.state.USER_PARENT_ID}`;
      if (selectedPageFilter) {
        url += `&page_id=${selectedPageFilter}`;
      }

      const response = await axios.get(url);
      this.setState({ unreadCount: response.data.data?.unread_count || 0 });
    } catch (err) {
      console.error("Error loading unread count:", err);
    }
  };

  // Phase 1: Handle search input change with debounce
  handleSearchChange = (e) => {
    const query = e.target.value;
    this.setState({ searchQuery: query });

    // Debounce search
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = setTimeout(() => {
      this.performSearch(query);
    }, 300);
  };

  // Phase 1: Perform search (local or API)
  performSearch = async (query) => {
    const { conversations, selectedPageFilter } = this.state;

    if (!query || query.trim().length < 2) {
      // Reset to full list (with page filter and unread filter if applied)
      let filtered = conversations;
      if (selectedPageFilter) {
        filtered = conversations.filter(
          (c) => c.page_id === selectedPageFilter,
        );
      }

      // Apply Unread Filter from Props if Active
      if (this.props.filterUnread) {
        filtered = filtered.filter((c) => c.unread_count > 0);
      }

      this.setState({ filteredConversations: filtered });
      return;
    }

    // Local search first for responsiveness
    const lowQ = query.toLowerCase();
    let filtered = conversations.filter(
      (c) =>
        (c.customer_name && c.customer_name.toLowerCase().includes(lowQ)) ||
        (c.last_message && c.last_message.toLowerCase().includes(lowQ)),
    );

    if (selectedPageFilter) {
      filtered = filtered.filter((c) => c.page_id === selectedPageFilter);
    }

    // Apply Unread Filter from Props if Active
    if (this.props.filterUnread) {
      filtered = filtered.filter((c) => c.unread_count > 0);
    }

    this.setState({ filteredConversations: filtered });
  };

  // Phase 1: Handle page filter change
  handlePageFilterChange = (e) => {
    const pageId = e.target.value;
    this.setState({ selectedPageFilter: pageId, searchQuery: "" }, () => {
      this.loadConversations();
      this.handleSyncMessages(); // Auto sync on page change
    });
  };

  loadMessages = async (conversationId) => {
    try {
      this.setState({ loadingMessages: true });
      const response = await axios.get(
        `${END_POINT}/api/facebook/messages/${conversationId}`,
      );
      this.setState(
        {
          messages: response.data.data || [],
          loadingMessages: false,
        },
        () => {
          setTimeout(() => {
            this.scrollToBottom();
          }, 100);
        },
      );
    } catch (err) {
      console.error("Error loading messages:", err);
      this.setState({ loadingMessages: false });
    }
  };

  handleSelectConversation = (conversation) => {
    this.setState({
      selectedConversation: conversation,
      messages: [],
    });
    this.loadMessages(conversation.id);

    // Mark as read in state
    this.setState((prev) => ({
      conversations: prev.conversations.map((c) =>
        c.id === conversation.id ? { ...c, is_read: true } : c,
      ),
    }));
  };

  handleNewMessage = (data) => {
    const { selectedConversation, conversations } = this.state;

    console.log("[FacebookChatApp] Received socket message:", {
      conversation_id: data.conversation_id,
      is_from_customer: data.is_from_customer,
      message_id: data.message?.message_id,
      sender_type: data.message?.sender_type,
    });

    // Skip page-sent messages from socket since we already add them optimistically
    // when sending via handleSendMessage / handleSendAttachment
    if (data.is_from_customer === false || data.message?.sender_type === "page") {
      // Still update conversation list metadata (last_message etc.)
      const updatedConversations = conversations.map((c) => {
        if (c.id === data.conversation_id) {
          return {
            ...c,
            last_message: data.message?.message_text || "[Attachment]",
            last_message_time:
              data.message?.timestamp || new Date().toISOString(),
          };
        }
        return c;
      });
      updatedConversations.sort(
        (a, b) => new Date(b.last_message_time) - new Date(a.last_message_time),
      );
      this.setState({
        conversations: updatedConversations,
        filteredConversations: updatedConversations,
      });
      return;
    }

    // Customer message - update conversations list
    const updatedConversations = conversations.map((c) => {
      if (c.id === data.conversation_id) {
        return {
          ...c,
          last_message: data.message?.message_text || "[Attachment]",
          last_message_time:
            data.message?.timestamp || new Date().toISOString(),
          is_read:
            selectedConversation &&
            selectedConversation.id === data.conversation_id,
        };
      }
      return c;
    });

    // Check if conversation exists, if not add it
    const conversationExists = conversations.some(
      (c) => c.id === data.conversation_id,
    );

    if (!conversationExists) {
      // Reload conversations to get new one
      this.loadConversations();
    } else {
      // Sort by last message time
      updatedConversations.sort(
        (a, b) => new Date(b.last_message_time) - new Date(a.last_message_time),
      );

      // Also update filteredConversations
      this.setState({
        conversations: updatedConversations,
        filteredConversations: updatedConversations,
      });
    }

    // Add message to current conversation if selected (with dedup check)
    if (
      selectedConversation &&
      selectedConversation.id === data.conversation_id &&
      data.message
    ) {
      this.setState(
        (prev) => {
          // Prevent duplicate messages by checking message_id
          const isDuplicate = data.message.message_id &&
            prev.messages.some((m) => m.message_id === data.message.message_id);
          if (isDuplicate) {
            return null; // No state change
          }
          return {
            messages: [...prev.messages, data.message],
          };
        },
        () => {
          // Scroll to bottom after state update
          this.scrollToBottom();
        },
      );
    }

    // Update unread count
    this.loadUnreadCount();

    // Notify parent about conversation updates
    if (this.props.onConversationsUpdate) {
      this.props.onConversationsUpdate(updatedConversations);
    }
  };

  handleSendMessage = async () => {
    const { messageInput, selectedConversation, selectedMessageTag } =
      this.state;

    if (!messageInput.trim() || !selectedConversation) return;

    try {
      this.setState({ sendingMessage: true });

      // Prepare request body
      const requestBody = {
        page_id: selectedConversation.page_id,
        psid: selectedConversation.psid,
        message: messageInput,
      };

      // Include message_tag if conversation is outside 24h window
      if (!selectedConversation.is_within_24h && selectedMessageTag) {
        requestBody.message_tag = selectedMessageTag;
      }

      await axios.post(`${END_POINT}/api/facebook/send`, requestBody);

      // Add message to UI immediately
      const newMessage = {
        id: Date.now(),
        conversation_id: selectedConversation.id,
        sender_type: "page",
        message_text: messageInput,
        timestamp: new Date().toISOString(),
      };

      this.setState(
        (prev) => {
          const updatedConversations = prev.conversations.map((c) =>
            c.id === selectedConversation.id
              ? {
                  ...c,
                  last_message: messageInput,
                  last_message_time: new Date().toISOString(),
                  updated_at: new Date().toISOString(),
                }
              : c,
          );

          return {
            messages: [...prev.messages, newMessage],
            messageInput: "",
            sendingMessage: false,
            selectedMessageTag: "",
            conversations: updatedConversations,
            filteredConversations: updatedConversations,
          };
        },
        () => {
          // Notify Parent in callback
          if (this.props.onConversationsUpdate) {
            this.props.onConversationsUpdate(this.state.conversations);
          }
        },
      );
    } catch (err) {
      console.error("Error sending message:", err);

      let errorMessage = this.props.intl.formatMessage({
        id: "chat.facebook.send_file_error",
      });

      if (err.response && err.response.data) {
        if (err.response.data.error) {
          errorMessage =
            typeof err.response.data.error === "string"
              ? err.response.data.error
              : JSON.stringify(err.response.data.error);
        } else if (err.response.data.message) {
          errorMessage = err.response.data.message;
        }
      } else if (err.message) {
        errorMessage = err.message;
      }

      NotificatioErrController(errorMessage);
      this.setState({ sendingMessage: false });
    }
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      this.handleSendMessage();
    }
  };

  // Phase 2: Handle quick reply selection
  handleQuickReplySelect = (content) => {
    this.setState({
      messageInput: content,
      showQuickReplyPanel: false,
    });
  };

  toggleQuickReplyPanel = () => {
    this.setState((prev) => ({
      showQuickReplyPanel: !prev.showQuickReplyPanel,
    }));
  };

  // Phase 3: Attachment handling
  handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Determine attachment type
    let attachmentType = "file";
    if (file.type.startsWith("image/")) {
      attachmentType = "image";
    } else if (file.type.startsWith("video/")) {
      attachmentType = "video";
    } else if (file.type.startsWith("audio/")) {
      attachmentType = "audio";
    }

    // Create preview for images
    let preview = null;
    if (attachmentType === "image") {
      preview = URL.createObjectURL(file);
    }

    this.setState({
      selectedAttachment: {
        file,
        preview,
        type: attachmentType,
        name: file.name,
      },
    });

    // Reset input
    e.target.value = "";
  };

  clearAttachment = () => {
    const { selectedAttachment } = this.state;
    if (selectedAttachment && selectedAttachment.preview) {
      URL.revokeObjectURL(selectedAttachment.preview);
    }
    this.setState({ selectedAttachment: null });
  };

  handleSendAttachment = async () => {
    const { selectedConversation, selectedAttachment, selectedMessageTag } =
      this.state;

    if (!selectedConversation || !selectedAttachment) return;

    try {
      this.setState({ uploadingAttachment: true });

      // Use combined upload and send endpoint
      const formData = new FormData();
      formData.append("file", selectedAttachment.file);
      formData.append("page_id", selectedConversation.page_id);
      formData.append("psid", selectedConversation.psid);
      formData.append("attachment_type", selectedAttachment.type);

      if (!selectedConversation.is_within_24h && selectedMessageTag) {
        formData.append("message_tag", selectedMessageTag);
      }

      const response = await axios.post(
        `${END_POINT}/api/facebook/upload-and-send`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      const responseData = response.data.data;
      const attachmentUrl = responseData.attachment_url;

      // Add to UI
      const newMessage = {
        id: Date.now(),
        conversation_id: selectedConversation.id,
        sender_type: "page",
        message_text: `[${selectedAttachment.type.toUpperCase()}]`,
        attachment_type: selectedAttachment.type,
        attachment_url: attachmentUrl,
        timestamp: new Date().toISOString(),
      };

      this.setState(
        (prev) => {
          const updatedConversations = prev.conversations.map((c) =>
            c.id === selectedConversation.id
              ? {
                  ...c,
                  last_message: `[${selectedAttachment.type.toUpperCase()}]`,
                  last_message_time: new Date().toISOString(),
                  updated_at: new Date().toISOString(),
                }
              : c,
          );

          return {
            messages: [...prev.messages, newMessage],
            selectedAttachment: null,
            uploadingAttachment: false,
            selectedMessageTag: "",
            conversations: updatedConversations,
            filteredConversations: updatedConversations,
          };
        },
        () => {
          if (this.props.onConversationsUpdate) {
            this.props.onConversationsUpdate(this.state.conversations);
          }
        },
      );

      // Scroll to bottom
      if (this._scrollBarRef) {
        this._scrollBarRef.scrollToBottom();
      }
    } catch (err) {
      console.error("Error upload/send:", err);
      let errorMessage = this.props.intl.formatMessage({
        id: "chat.facebook.send_error",
      });

      if (err.response && err.response.data) {
        if (err.response.data.error) {
          errorMessage =
            typeof err.response.data.error === "string"
              ? err.response.data.error
              : JSON.stringify(err.response.data.error);
        } else if (err.response.data.message) {
          errorMessage = err.response.data.message;
        }
      } else if (err.message) {
        errorMessage = err.message;
      }

      NotificatioErrController(errorMessage);
      this.setState({ uploadingAttachment: false });
    }
  };

  handlePreviewPages = async () => {
    const { manualToken } = this.state;
    if (!manualToken || !manualToken.trim()) {
      this.setState({
        socialError: this.props.intl.formatMessage({
          id: "facebook.manual.error-empty",
        }),
      });
      return;
    }

    this.setState({ previewLoading: true, socialError: null, previewPages: [] });

    try {
      const user_id = localStorage.getItem("b");
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.post(
        `${END_POINT}/api/facebook/preview-pages`,
        {
          user_id,
          page_access_token: manualToken.trim(),
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      const pages = response.data.data || [];
      const allIds = new Set(pages.map((p) => p.page_id));

      this.setState({
        previewLoading: false,
        previewPages: pages,
        selectedPageIds: allIds,
      });
    } catch (err) {
      const errorMsg =
        err.response?.data?.error ||
        this.props.intl.formatMessage({
          id: "facebook.manual.error-failed",
        });
      this.setState({
        previewLoading: false,
        socialError: errorMsg,
      });
    }
  };

  handleConnectSelectedPages = async () => {
    const { manualToken, selectedPageIds } = this.state;
    if (selectedPageIds.size === 0) {
      this.setState({
        socialError: this.props.intl.formatMessage({
          id: "facebook.manual.error-no-selection",
        }),
      });
      return;
    }

    this.setState({ connectingManualToken: true, socialError: null });

    try {
      const user_id = localStorage.getItem("b");
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.post(
        `${END_POINT}/api/facebook/manual-connect`,
        {
          user_id,
          page_access_token: manualToken.trim(),
          selected_page_ids: Array.from(selectedPageIds),
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      );

      this.setState({
        connectingManualToken: false,
        manualToken: "",
        showManualToken: false,
        previewPages: [],
        selectedPageIds: new Set(),
        socialSuccess: response.data.message,
      });

      // Reload pages immediately after successful connection
      this.setState({ loadingPages: true });
      this.loadPages();
      this.loadConversations();
    } catch (err) {
      const errorMsg =
        err.response?.data?.error ||
        this.props.intl.formatMessage({
          id: "facebook.manual.error-failed",
        });
      this.setState({
        connectingManualToken: false,
        socialError: errorMsg,
      });
    }
  };

  togglePageSelection = (pageId) => {
    this.setState((prev) => {
      const newSet = new Set(prev.selectedPageIds);
      if (newSet.has(pageId)) {
        newSet.delete(pageId);
      } else {
        newSet.add(pageId);
      }
      return { selectedPageIds: newSet };
    });
  };

  toggleSelectAll = () => {
    this.setState((prev) => {
      const allSelected = prev.selectedPageIds.size === prev.previewPages.length;
      if (allSelected) {
        return { selectedPageIds: new Set() };
      }
      return {
        selectedPageIds: new Set(prev.previewPages.map((p) => p.page_id)),
      };
    });
  };

  render() {
    const {
      pages,
      filteredConversations,
      selectedConversation,
      messages,
      messageInput,
      loadingConversations,
      loadingMessages,
      sendingMessage,
      isSyncing,
      // Phase 1: New state
      searchQuery,
      selectedPageFilter,
      unreadCount,
      // Phase 2: Quick Replies
      showQuickReplyPanel,
      // Token Status
      tokenStatus,
      tokenCheckDone,
      // Phase 3: Attachments
      selectedAttachment,
      uploadingAttachment,
    } = this.state;

    if (!this.state.loadingPages && !this.state.loadingConversations && pages.length === 0) {
      return (
        <Row className="pr-4">
          <Colxx xxs="12">
            <Card className="h-100 mb-4" style={{ minHeight: "75vh" }}>
              <CardBody className="d-flex flex-column justify-content-center align-items-center text-center">
                {this.state.socialError && (
                  <Alert color="danger" className="mb-4">
                    {this.state.socialError}
                    <button
                      className="close"
                      onClick={() => this.setState({ socialError: null })}
                    >
                      ×
                    </button>
                  </Alert>
                )}
                {this.state.socialSuccess && (
                  <Alert color="success" className="mb-4">
                    {this.state.socialSuccess}
                    <button
                      className="close"
                      onClick={() => this.setState({ socialSuccess: null })}
                    >
                      ×
                    </button>
                  </Alert>
                )}

                <div
                  className="rounded-circle d-flex align-items-center justify-content-center mb-4"
                  style={{ width: 80, height: 80, backgroundColor: 'rgba(24, 119, 242, 0.1)' }}
                >
                  <i
                    className="iconsminds-facebook"
                    style={{ color: "#1877f2", fontSize: 40 }}
                  />
                </div>

                {!this.state.showManualToken ? (
                  <>
                    <h3 className="mb-3 font-weight-bold">
                      <IntlMessages id="facebook.no-pages" />
                    </h3>
                    <p className="text-muted mb-5" style={{ maxWidth: 500 }}>
                      <IntlMessages id="facebook.description" />
                    </p>
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center" style={{ gap: "15px" }}>
                      <Button
                        color="primary"
                        size="lg"
                        className="mb-2 mb-sm-0 shadow-sm px-4"
                        onClick={this.handleConnectFacebookOAuth}
                      >
                        <i className="simple-icon-social-facebook mr-2" />
                        <IntlMessages id="facebook.connect-new" />
                      </Button>
                      <Button
                        color="outline-primary"
                        size="lg"
                        className="shadow-sm px-4"
                        onClick={() => {
                          this.setState({ showManualToken: true });
                        }}
                      >
                        <i className="simple-icon-key mr-2" />
                        <IntlMessages id="facebook.manual.btn" />
                      </Button>
                    </div>
                  </>
                ) : (
                  <div className="w-100 text-left" style={{ maxWidth: 600 }}>
                    <div className="d-flex align-items-center justify-content-between mb-4">
                      <h4 className="mb-0 font-weight-bold">
                        <i className="simple-icon-key mr-2" style={{ color: "#1877f2" }} />
                        <IntlMessages id="facebook.manual.title" />
                      </h4>
                      <Button
                        color="link"
                        onClick={() => this.setState({ showManualToken: false, manualToken: "", previewPages: [], socialError: null })}
                        className="p-0 text-muted"
                      >
                        <i className="simple-icon-action-undo text-lg" /> Quay lại
                      </Button>
                    </div>

                    <p className="text-muted mb-3">
                      <IntlMessages id="facebook.manual.desc" />
                    </p>

                    {/* Step 1: Token Input */}
                    <div className="d-flex mb-4" style={{ gap: "10px" }}>
                      <Input
                        type="textarea"
                        rows="2"
                        placeholder={this.props.intl.formatMessage({ id: "facebook.manual.placeholder" })}
                        value={this.state.manualToken}
                        onChange={(e) =>
                          this.setState({
                            manualToken: e.target.value,
                            previewPages: [],
                            selectedPageIds: new Set(),
                          })
                        }
                        style={{ fontFamily: "monospace" }}
                        disabled={this.state.previewLoading}
                      />
                      <Button
                        color="info"
                        onClick={this.handlePreviewPages}
                        disabled={this.state.previewLoading || !this.state.manualToken.trim()}
                        style={{ minWidth: "120px" }}
                      >
                        {this.state.previewLoading ? (
                          <span>
                            <i className="simple-icon-refresh spin-animation mr-1" />
                            <IntlMessages id="facebook.manual.checking" />
                          </span>
                        ) : (
                          <span>
                            <i className="simple-icon-magnifier mr-1" />
                            <IntlMessages id="facebook.manual.check-btn" />
                          </span>
                        )}
                      </Button>
                    </div>

                    {/* Step 2: Page Selection List */}
                    {this.state.previewPages.length > 0 && (
                      <div className="mt-3 text-left">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="mb-0 font-weight-bold">
                            <i className="simple-icon-list mr-1" />
                            <IntlMessages id="facebook.manual.select-pages" />
                            <span className="badge badge-primary ml-2">{this.state.previewPages.length}</span>
                          </h6>
                          {this.state.previewPages.length > 1 && (
                            <Button color="link" size="sm" onClick={this.toggleSelectAll} className="p-0">
                              {this.state.selectedPageIds.size === this.state.previewPages.length
                                ? this.props.intl.formatMessage({ id: "facebook.manual.deselect-all" })
                                : this.props.intl.formatMessage({ id: "facebook.manual.select-all" })}
                            </Button>
                          )}
                        </div>

                        <div className="border rounded" style={{ maxHeight: "250px", overflowY: "auto", backgroundColor: "#fff" }}>
                          {this.state.previewPages.map((page) => (
                            <div
                              key={page.page_id}
                              className="d-flex align-items-center p-2 border-bottom"
                              style={{
                                cursor: "pointer",
                                backgroundColor: this.state.selectedPageIds.has(page.page_id) ? "#e8f4fd" : "transparent",
                              }}
                              onClick={() => this.togglePageSelection(page.page_id)}
                            >
                              <input
                                type="checkbox"
                                checked={this.state.selectedPageIds.has(page.page_id)}
                                onChange={() => {}}
                                className="mr-3 ml-2"
                                style={{ transform: "scale(1.2)", cursor: "pointer" }}
                              />
                              <div className="rounded-circle mr-3 d-flex align-items-center justify-content-center bg-primary text-white font-weight-bold" style={{ width: 40, height: 40 }}>
                                {page.page_name.charAt(0).toUpperCase()}
                              </div>
                              <div className="flex-grow-1">
                                <strong style={{ fontSize: "14px" }}>{page.page_name}</strong>
                                <div className="text-muted" style={{ fontSize: "12px" }}>ID: {page.page_id}</div>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="mt-3 d-flex align-items-center" style={{ gap: "10px" }}>
                          <Button
                            color="success"
                            onClick={this.handleConnectSelectedPages}
                            disabled={this.state.connectingManualToken || this.state.selectedPageIds.size === 0}
                          >
                            {this.state.connectingManualToken ? (
                              <span><i className="simple-icon-refresh spin-animation mr-1" /><IntlMessages id="facebook.manual.connecting" /></span>
                            ) : (
                              <span><i className="simple-icon-check mr-1" /><IntlMessages id="facebook.manual.connect-btn" /></span>
                            )}
                          </Button>
                          <span className="text-muted" style={{ fontSize: "13px" }}>
                            {this.state.selectedPageIds.size} / {this.state.previewPages.length} {this.props.intl.formatMessage({ id: "facebook.manual.pages-selected" })}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      );
    }

    return (
      <Row className="pr-4">
        {/* Conversations sidebar */}
        <Colxx xxs="12" md="5" lg="4">
          <Card className="h-100">
            <CardBody
              className="p-0 d-flex flex-column"
              style={{ height: "75vh" }}
            >
              {/* Header with title and sync button */}
              <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
                <h6 className="mb-0">
                  <i
                    className="iconsminds-facebook mr-2"
                    style={{ color: "#1877f2" }}
                  />
                  <IntlMessages id="chat.facebook.messenger" />
                  {unreadCount > 0 && (
                    <span
                      className="badge badge-danger ml-2"
                      style={{ fontSize: 10 }}
                    >
                      {unreadCount}
                    </span>
                  )}
                </h6>
                <div />
              </div>

              {/* Token Expired Warning Banner */}
              {tokenCheckDone && tokenStatus && tokenStatus.has_expired && (
                <div
                  className="px-3 py-2 border-bottom"
                  style={{
                    backgroundColor: "#fff3cd",
                    borderLeft: "4px solid #ffc107",
                  }}
                >
                  <div className="d-flex align-items-start">
                    <i
                      className="simple-icon-exclamation mr-2 mt-1"
                      style={{ color: "#856404", fontSize: 16 }}
                    />
                    <div className="flex-grow-1" style={{ fontSize: 12 }}>
                      <strong style={{ color: "#856404" }}>
                        <IntlMessages id="chat.facebook.token_expired_title" />
                      </strong>
                      <div className="text-muted mt-1">
                        {tokenStatus.pages
                          .filter((p) => !p.is_valid)
                          .map((p) => p.page_name)
                          .join(", ")}
                      </div>
                      <a
                        href="/app/applications/setting"
                        className="btn btn-warning btn-xs mt-2 d-inline-flex align-items-center"
                        style={{ fontSize: 11 }}
                      >
                        <i className="simple-icon-link mr-1" />
                        <IntlMessages id="chat.facebook.token_reconnect_btn" />
                      </a>
                    </div>
                    <button
                      type="button"
                      className="close ml-2"
                      style={{ fontSize: 14 }}
                      onClick={() =>
                        this.setState({
                          tokenStatus: { ...tokenStatus, has_expired: false },
                        })
                      }
                    >
                      &times;
                    </button>
                  </div>
                </div>
              )}

              {/* Phase 1: Search and Filter */}
              <div className="p-2 border-bottom">
                <Input
                  type="text"
                  placeholder={this.props.intl.formatMessage({
                    id: "chat.facebook.search_customer",
                  })}
                  value={searchQuery}
                  onChange={this.handleSearchChange}
                  className="mb-2"
                  bsSize="sm"
                />
                {pages.length > 1 && (
                  <Input
                    type="select"
                    value={selectedPageFilter}
                    onChange={this.handlePageFilterChange}
                    bsSize="sm"
                  >
                    <option value="">
                      {this.props.intl.formatMessage({ id: "chat.facebook.all_pages" })}
                    </option>
                    {pages.map((p) => (
                      <option key={p.page_id} value={p.page_id}>
                        {p.page_name}
                      </option>
                    ))}
                  </Input>
                )}
              </div>

              <div className="flex-grow-1 position-relative overflow-hidden">
                <FacebookConversationList
                  conversations={filteredConversations}
                  selectedConversation={selectedConversation}
                  onSelectConversation={this.handleSelectConversation}
                  loading={loadingConversations}
                  pages={pages}
                  selectedPageFilter={selectedPageFilter}
                />
              </div>
            </CardBody>
          </Card>
        </Colxx>

        {/* Chat area */}
        <Colxx xxs="12" md="7" lg="8">
          <Card className="h-100">
            <CardBody
              className="px-3 py-0 d-flex flex-column"
              style={{ height: "75vh" }}
            >
              {selectedConversation ? (
                <>
                  {/* Chat header */}
                  <div className="p-3 border-bottom d-flex align-items-center">
                    {selectedConversation.customer_profile_pic ? (
                      <img
                        src={selectedConversation.customer_profile_pic}
                        alt=""
                        className="rounded-circle mr-3"
                        style={{ width: 40, height: 40, objectFit: "cover" }}
                      />
                    ) : (
                      <div
                        className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white mr-3"
                        style={{ width: 40, height: 40 }}
                      >
                        {selectedConversation.customer_name?.charAt(0) || "K"}
                      </div>
                    )}
                    <div>
                      <h6 className="mb-0">
                        {selectedConversation.customer_name || (
                          <IntlMessages id="chat.facebook.customer" />
                        )}
                      </h6>
                      <small className="text-muted">
                        {pages.find(
                          (p) => p.page_id === selectedConversation.page_id,
                        )?.page_name || ""}
                      </small>
                    </div>
                  </div>

                  {/* Messages */}
                  <div className="flex-grow-1 position-relative overflow-hidden">
                    <PerfectScrollbar
                      className="h-100 p-3"
                      options={{ suppressScrollX: true }}
                      ref={(ref) => {
                        this._scrollBarRef = ref;
                      }}
                    >
                      {loadingMessages ? (
                        <div className="d-flex flex-column h-100 align-items-center justify-content-center">
                          <div
                            className="loading position-relative"
                            style={{ height: 50, width: 50, margin: "0 auto" }}
                          />
                          <p className="text-muted mt-3">
                            <IntlMessages id="chat.facebook.processing" />
                          </p>
                        </div>
                      ) : messages.length === 0 ? (
                        <div className="text-center text-muted py-5">
                          <p>
                            <IntlMessages id="chat.facebook.no_messages" />
                          </p>
                        </div>
                      ) : (
                        <>
                          {messages.map((msg, idx) => {
                            // Logic to hide time if next message is same minute and same sender?
                            // User request: "nếu các tin nhắn cùng giờ và phút thì bạn hãy bỏ hiển thị giờ cho các tin nhắn phía trên nhé, chỉ hiển thị cho tin nhắn cuối cùng của giờ đó"
                            // Means we compare with NEXT message.

                            let showTime = true;
                            const nextMsg = messages[idx + 1];

                            if (nextMsg) {
                              const currentMoment = moment(msg.timestamp);
                              const nextMoment = moment(nextMsg.timestamp);

                              if (currentMoment.isSame(nextMoment, "minute")) {
                                showTime = false;
                              }
                            }

                            return (
                              <FacebookMessageCard
                                key={msg.id || idx}
                                item={msg}
                                showTime={showTime}
                                customerName={
                                  selectedConversation.customer_name
                                }
                                customerPic={
                                  selectedConversation.customer_profile_pic
                                }
                              />
                            );
                          })}
                        </>
                      )}
                    </PerfectScrollbar>
                  </div>

                  {/* Phase 2: Quick Reply Panel */}
                  <QuickReplyPanel
                    isOpen={showQuickReplyPanel}
                    onToggle={this.toggleQuickReplyPanel}
                    onSelectTemplate={this.handleQuickReplySelect}
                  />

                  {/* 24h Window Warning */}
                  {selectedConversation &&
                    !selectedConversation.is_within_24h && (
                      <div className="px-3 py-2 bg-warning-light border-top">
                        <div className="d-flex align-items-center justify-content-between">
                          <small className="text-warning">
                            <i className="simple-icon-clock mr-1" />
                            <IntlMessages id="chat.facebook.outside_24h" />
                          </small>
                          <Input
                            type="select"
                            bsSize="sm"
                            className="custom-select"
                            style={{ width: "auto", minWidth: 200 }}
                            value={this.state.selectedMessageTag}
                            onChange={(e) =>
                              this.setState({
                                selectedMessageTag: e.target.value,
                              })
                            }
                          >
                            <option value="">
                              {this.props.intl.formatMessage({
                                id: "chat.facebook.select_tag",
                              })}
                            </option>
                            <option value="HUMAN_AGENT">
                              {this.props.intl.formatMessage({
                                id: "chat.facebook.tag.human_agent",
                              })}
                            </option>
                            <option value="POST_PURCHASE_UPDATE">
                              {this.props.intl.formatMessage({
                                id: "chat.facebook.tag.post_purchase",
                              })}
                            </option>
                            <option value="ACCOUNT_UPDATE">
                              {this.props.intl.formatMessage({
                                id: "chat.facebook.tag.account_update",
                              })}
                            </option>
                            <option value="CONFIRMED_EVENT_UPDATE">
                              {this.props.intl.formatMessage({
                                id: "chat.facebook.tag.event_update",
                              })}
                            </option>
                          </Input>
                        </div>
                      </div>
                    )}

                  {/* Phase 3: Attachment Preview */}
                  {selectedAttachment && (
                    <div className="px-3 py-2 border-top bg-light">
                      <div className="d-flex align-items-center">
                        {selectedAttachment.preview ? (
                          <img
                            src={selectedAttachment.preview}
                            alt="Preview"
                            style={{
                              maxHeight: 60,
                              maxWidth: 100,
                              borderRadius: 4,
                            }}
                          />
                        ) : (
                          <div
                            className="d-flex align-items-center justify-content-center bg-secondary text-white rounded"
                            style={{ width: 60, height: 60 }}
                          >
                            <i
                              className="simple-icon-doc"
                              style={{ fontSize: 24 }}
                            />
                          </div>
                        )}
                        <div className="ml-2 flex-grow-1">
                          <small className="font-weight-bold d-block">
                            {selectedAttachment.name}
                          </small>
                          <small className="text-muted">
                            {selectedAttachment.type.toUpperCase()}
                          </small>
                        </div>
                        <Button
                          color="link"
                          size="sm"
                          className="text-danger"
                          onClick={this.clearAttachment}
                        >
                          <i className="simple-icon-close" />
                        </Button>
                        <Button
                          color="primary"
                          size="sm"
                          onClick={this.handleSendAttachment}
                          disabled={uploadingAttachment}
                        >
                          {uploadingAttachment ? (
                            <span className="spinner-border spinner-border-sm" />
                          ) : (
                            <>
                              <i className="simple-icon-paper-plane mr-1" />
                              <IntlMessages id="chat.facebook.send" />
                            </>
                          )}
                        </Button>
                      </div>
                    </div>
                  )}

                  {/* Input */}
                  <div className="p-3 border-top">
                    {/* Hidden file input */}
                    <input
                      type="file"
                      ref={this.fileInputRef}
                      style={{ display: "none" }}
                      accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx"
                      onChange={this.handleFileSelect}
                    />
                    <InputGroup>
                      {/* Quick Reply Button */}
                      <InputGroupAddon addonType="prepend">
                        <Button
                          color="light"
                          onClick={this.toggleQuickReplyPanel}
                          title="Trả lời nhanh"
                        >
                          <i className="simple-icon-bubbles" />
                        </Button>
                      </InputGroupAddon>
                      {/* Attachment Button */}
                      <InputGroupAddon addonType="prepend">
                        <Button
                          color="light"
                          onClick={() => this.fileInputRef.current.click()}
                          title="Đính kèm file"
                        >
                          <i className="simple-icon-paper-clip" />
                        </Button>
                      </InputGroupAddon>
                      <Input
                        type="text"
                        placeholder="Nhập tin nhắn..."
                        value={messageInput}
                        onChange={(e) =>
                          this.setState({ messageInput: e.target.value })
                        }
                        onKeyPress={this.handleKeyPress}
                        disabled={sendingMessage}
                      />
                      <InputGroupAddon addonType="append">
                        <Button
                          color="primary"
                          onClick={this.handleSendMessage}
                          disabled={!messageInput.trim() || sendingMessage}
                        >
                          {sendingMessage ? (
                            <span className="spinner-border spinner-border-sm" />
                          ) : (
                            <i className="simple-icon-paper-plane" />
                          )}
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </div>
                </>
              ) : (
                <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted py-5">
                  <i
                    className="iconsminds-speach-bubble-dialog mb-3"
                    style={{ fontSize: 60 }}
                  />
                  <h5>Chọn một cuộc hội thoại</h5>
                  <p>Chọn cuộc hội thoại từ danh sách bên trái để bắt đầu</p>
                </div>
              )}
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default injectIntl(FacebookChatApp);
